<template>
  <b-row>
    <template v-if="openedInModal">
      <b-col>
        <EXCMDeviceModelForm
                :openedInModal="openedInModal"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
      </b-col>
    </template>
    <template v-else>
      <b-col v-if="isLoading">
        <Loader size="lg"></Loader>
      </b-col>
      <b-col v-else>
        <b-row>
          <b-col>
            <router-link :to="{ name: 'EXCMDeviceModelList' }" class="btn btn-default float-right">
              <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <EXCMDeviceModelForm
                      :handle-submit="onSendForm"
                      :handle-update-field="updateField"
                      :values="item"
                      :errors="violations" />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMDeviceModelForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdevicemodel/create')

export default {
  components: {
    EXCMDeviceModelForm,
    Loader
  },

  props: {
    openedInModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceModelCreate')
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      if (this.openedInModal) {
        this.$store.state.modals.excmdevicemodel.form.close = 1
      } else {
        this.$router.push({ name: 'EXCMDeviceModelList', params: { id: created['@id'] } })
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
